module.exports = __webpack_public_path__ + "static/media/ic-chat-white.8675d20d.svg";